import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Routes } from "./routes/Routes";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queryClient";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";

import "./i18n/i18n";
import { Toaster } from "react-hot-toast";
import { WebSocketProvider } from "./components/WebSocketProvider";
import { ThemeModeProvider } from "./theme/ThemeModeContext";
import { SubscriptionProvider } from "./contexts/SubscriptionContext";
import { PermissionProvider } from "./contexts/PermissionContext";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeModeProvider>
            <Toaster position="top-right" reverseOrder={false} />
            <QueryClientProvider client={queryClient}>
              <WebSocketProvider
                url={process.env.REACT_APP_WS_URL || "https://websocket.codenekt.com"}
                autoConnect={true}
              >
                <BrowserRouter>
                  {/* Two independent gates, nested deliberately:
                      PermissionProvider answers "may THIS USER do it?" (role),
                      SubscriptionProvider answers "has THIS COMPANY bought
                      it?" (plan). A screen usually needs both. */}
                  <PermissionProvider>
                    <SubscriptionProvider>
                      <Routes />
                    </SubscriptionProvider>
                  </PermissionProvider>
                </BrowserRouter>
              </WebSocketProvider>
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </ThemeModeProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
